import { CommonModule } from "@angular/common";
import { Component, ViewEncapsulation } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";
import { ICONS } from '../../../../_helpers/icons.constants';

@Component({
  selector: 'click-to-setup-cell',
  templateUrl: './click-to-setup-renderer.component.html',
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [CommonModule, TranslateModule]
})

export class ClickToSetupRendererComponent implements ICellRendererAngularComp {
  text: string = '';
  class: string = '';
  actionButtons: any[] = [];
  params: ICellRendererParams;
  constructor() { }
  public ICONS = ICONS;
  /**
   * Writes the chosen action onto the row and re-fires the cell click, the same contract as
   * `actionRenderer` / `iconButtonsRenderer` / `buttonsRenderer`, so a host that already reads
   * `row.userAction` needs no special case for this renderer.
   *
   * The template used to pass the whole button descriptor here, which put an OBJECT on
   * `row.userAction` where every other renderer puts the action itself.
   */
  onUserAction(action) {
    this.params.data.userAction = action;
    this.params.node.setData(this.params.data);
    this.params.eGridCell.click();
  }

  /**
   * Params: `headerComponentParams` is an array of `{ text, class?, userAction, showProperty?,
   * hideProperty?, showGreenTick? }`. `showProperty` / `hideProperty` name boolean row flags -
   * `hideProperty` true hides the link, `showProperty` false hides it.
   *
   * Both were previously dead: the logic below them was inverted (a truthy `showProperty` HID the
   * link) and then overwritten outright by a `//delete after testing` line that forced every link
   * visible. Only the eod-template showcase used this renderer at the time - the ~13 production
   * consumers are on the legacy `shared/grid/` copy, which is a separate file and untouched.
   */
  initilize(params: ICellRendererParams) {
    if (params && params.data) {
      this.params = params;
      this.actionButtons = JSON.parse(JSON.stringify(params.colDef.headerComponentParams));
      for (const button of this.actionButtons) {
        button.isHidden =
          !!(button.hideProperty && this.params.data[button.hideProperty]) ||
          !!(button.showProperty && !this.params.data[button.showProperty]);
      }
    }
    else {
      this.actionButtons = [];
    }
  }

  showEditGradePanelFunction() {
  }

  agInit(params: any): void {
    this.initilize(params);
  }

  refresh(params: any): boolean {
    this.initilize(params);
    return true;
  }

}
